import axiosInstance from "../api/api";

const ReviewService = {
    list: function () {
        return axiosInstance({
            url: "/api/review/",
            method: "GET",
        });
    },
    fetchSettingForUser: function () {
        return axiosInstance({
            url: "/api/review/setting",
            method: "GET",
        });
    },
    lastContactDate: function (contactId) {
        return axiosInstance({
            url: `/api/review/lastContact/${contactId}`,
            method: "GET",
        });
    },
    listByTenant: function () {
        return axiosInstance({
            url: "/api/review/tenant",
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/${uniqueId}`,
            method: "GET",
        });
    },
    userReviewDetails: function (uniqueId) {
        let url = `/api/review/userReviewDetails/${uniqueId}`
        if(uniqueId === undefined) {
            url = `/api/review/userReviewDetails/`
        }
        return axiosInstance({
            url: url,
            method: "GET",
        });
    },
    historicDataForCurrentUser: function (data) {
        let url = '/api/review/historicData';
        if (data && (data.dateFrom || data.dateTo)) {
            const params = new URLSearchParams();
            if (data.dateFrom) params.append('fromDate', data.dateFrom);
            if (data.dateTo) params.append('toDate', data.dateTo);
            url += `?${params.toString()}`;
        }
        return axiosInstance({
            url: url,
            method: "GET",
        });
    },
    unansweredContacts: function () {
        return axiosInstance({
            url: `/api/review/unanswered/`,
            method: "GET",
        });
    },
    fetchSurveyDetails: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/surveydetails/${uniqueId}`,
            method: "GET",
        });
    },
    toggleShowAsTestimonial: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/toggleShowAsTestimonial/${uniqueId}`,
            method: "PUT",
        });
    },
    xareviewData: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/xareview`,
            method: "GET",
        });
    },
    partnersData: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/partners`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/${uniqueId}`,
            method: "DELETE",
        });
    },
    deleteAudience: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/deleteAudience/${uniqueId}`,
            method: "DELETE",
        });
    },
    createSetting: function (formData) {
        return axiosInstance({
            url: `/api/review/setting`,
            method: "POST",
            data: formData,
        });
    },
    createReviewCampaign: function (formData) {
        return axiosInstance({
            url: `/api/review/campaign`,
            method: "POST",
            data: formData,
        });
    },
    submitReviewAnswers: function (formData) {
        return axiosInstance({
            url: `/api/review/submit`,
            method: "POST",
            data: formData,
        });
    },
    updateCompanyDescription: function (formData) {
        return axiosInstance({
            url: `/api/review/updateCompanyDescription`,
            method: "POST",
            data: formData,
        });
    },
    companyDescription: function (uniqueId) {
        return axiosInstance({
            url: `/api/review/companyDescription/${uniqueId}`,
            method: "GET",
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/review/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default ReviewService;
